/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanySearchFilterCompanyProfileStatus = 'NotPurchased' | 'ActiveOrPurchased' | 'Expired';

export const CompanySearchFilterCompanyProfileStatus = {
    NotPurchased: 'NotPurchased' as CompanySearchFilterCompanyProfileStatus,
    ActiveOrPurchased: 'ActiveOrPurchased' as CompanySearchFilterCompanyProfileStatus,
    Expired: 'Expired' as CompanySearchFilterCompanyProfileStatus
};

